import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single-blog", (props) => {
  return <ContentBlocks className="text-wrap" blocks={props.blog?.contentBlocks} />
})
